// components/Scheduler/index.js

import Scheduler from './Scheduler';

export default Scheduler;
